import { useComponentTheme } from '#hooks/UNSAFE_useComponentTheme';
import { classNames } from '#utils/UNSAFE_classNames';
import { textInterpolations } from '#utils/UNSAFE_interpolations/text';
import { mergeInterpolations } from '#utils/UNSAFE_mergeInterpolations';
import { LabelledLinkVariantOptions } from './themes/LabelledLinkStyles.css';
import { LabelledLinkRedwoodTheme } from './themes/redwood/LabelledLinkTheme';

type UseLabelledLinkThemeProps = {
  hasInsideLabel?: boolean;
  isFormLayout?: boolean;
  isFormReadonly?: boolean;
  textAlign?: 'start' | 'end' | 'right';
};

export function useLabelledLinkTheme({
  hasInsideLabel,
  isFormLayout,
  isFormReadonly,
  textAlign
}: UseLabelledLinkThemeProps) {
  // Style interpolations for text align
  const interpolations = [...Object.values(textInterpolations)];
  const styleInterpolations = mergeInterpolations<UseLabelledLinkThemeProps>(interpolations);

  // Calculate the style interpolation classes
  const { class: styleInterpolationClasses } = styleInterpolations({ textAlign });
  // Calculate the theme classes
  const { classes: themeClasses } = useComponentTheme<LabelledLinkVariantOptions>(
    LabelledLinkRedwoodTheme,
    {
      formLayout: isFormLayout ? 'isFormLayout' : 'notFormLayout',
      readonlyForm: isFormReadonly ? 'isReadonlyForm' : 'notReadonlyForm',
      insideLabel: hasInsideLabel ? 'hasInsideLabel' : 'noInsideLabel'
    }
  );
  // merge all the classes
  const classes = classNames([styleInterpolationClasses, themeClasses]);

  return { classes };
}
